<div class="resultsView verticalCenterView">
    
    <div class="resultsView__searchInfo" *ngIf="showClosestRegionMessage">
        <div class="w-100" style="text-align: center; font-weight: bold; font-size: 13px">No results for {{SubregionName}}, {{RegionName}}</div>
        <div class="w-100" style="text-align: center; font-weight: bold;">Showing results from {{ClosestSubregionNameIfNoResult}}</div>
    </div>
    <div class="resultsView__loader" *ngIf="loading"><mat-spinner diameter="60" ></mat-spinner></div>
    <div class="resultsView__noResults" *ngIf="!loading && cardList.length<=0">0 results</div>
    
    <mat-list class="resultsView__adsList"  role="list" *ngIf="!loading">
        
        <ng-container *ngFor="let card of cardList; let _i = index">
            <mat-list-item 
            class="adsItem resultsView__adsItem"  
            role="listitem" 
            (click)="openAdv(card.advertisementId)" >
                <div class="adsItem__img">
                    <img [src]="getImageFromCard(card)" *ngIf="hasAdvertismentImage(card); else placeholderImage">
                    <ng-template #placeholderImage><img src="assets/img/user_placeholder.png" /></ng-template>
                </div>
                <div  class="adsItem__content">
                    <div class="adsItem__title">{{ getAdvTitle(card) }}</div>
                    <div class="adsItem__city">{{ getLocation(card) }}</div>
                </div>
                <div class="adsItem__btGoToAd">
                    <mat-icon aria-hidden="false" aria-label="search button">chevron_right</mat-icon>
                </div>
                <div class="adsItem__third-party-ad-text" *ngIf="card.isThirdParty">
                    <span style="color: #e94480">sponsored</span>
                </div>
                <div class="adsItem__starWrap" *ngIf="getPremiumText(card) != '' && enableSubscription" (click)="showTip($event)">
                    <i class="adsItem__starIcon material-icons">star</i>
                    <span class="textTip adsItem__textTip">{{getPremiumText(card)}}</span>
                </div> 
            </mat-list-item>

            <div class="adsContainer" *ngIf="(!isPremium || !service.enableSubscription) && (_i % 8) == 0 && _i != 0">
                <app-banner-zone-map [zoneType]="['Mobile-Ads', 'Mobile-Ads-2']" [isMobile]="true"></app-banner-zone-map>
            </div>
        </ng-container>

    </mat-list>
    <div class="resultsView__pagination" *ngIf="length > pageSize">   
        <mat-paginator 
         (page)="pageEvent = $event"
         [length]="length"
         [pageIndex]="pageNumber"
         [pageSize]="pageSize"
         [hidePageSize]="true"
         (page)="pageChange($event)">
        </mat-paginator>
    </div>     
</div>
